import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NgModule} from "@angular/core";
import {CollapseMenuComponent} from "./collapse-menu/collapse-menu.component";
import {FullScreenComponent} from "./full-screen/full-screen.component";
import {HeaderComponent} from "./header.component";
import {I18nModule} from "@app/shared/i18n/i18n.module";
import {UserModule} from "@app/shared/user/user.module";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { PopoverModule } from "ngx-bootstrap/popover";
import { SharedComponentsModule } from "@app/cp/shared/sharedComponents.module";

@NgModule({
  imports: [
    CommonModule,

    FormsModule,

    BsDropdownModule,

    I18nModule, UserModule, PopoverModule,
    SharedComponentsModule
  ],
  declarations: [
    FullScreenComponent,
    CollapseMenuComponent,
    HeaderComponent
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule{}
